module.exports = __webpack_public_path__ + "static/footer-background-594bcbe8e8eb38fc3c6e719848f3ae74.svg";